import { render, staticRenderFns } from "./ObservationsReportFiles.vue?vue&type=template&id=047c983a&"
import script from "./ObservationsReportFiles.vue?vue&type=script&lang=js&"
export * from "./ObservationsReportFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports